exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-wrap[data-v-5657fdcf] {\n  width: 100%;\n}\n.select-wrap-textarea[data-v-5657fdcf] {\n  font-size: 11px;\n  line-height: 13px;\n  color: #616161;\n  padding-top: 7px;\n  resize: none;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5657fdcf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/companies/CompaniesWebQuote.vue
// module id = IurP
// module chunks = 0